<template>
  <div class="home_view">
    <div class="nav_item"><router-link :to="{ name : 'about' }">About</router-link></div>
    <div class="nav_item"><router-link :to="{ name : 'career' }">Career</router-link></div>
    <div class="nav_item"><router-link :to="{ name : 'music' }">Music</router-link></div>
  </div>
</template>

<script>

export default {
    name : "Home"
};

</script>

<style scoped>

.home_view {
    padding:100px 0px;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
}

.nav_item {
    width:200px;
    height:100px;
    margin:80px 0px 0px;
    position:relative;
    font-size:36px;
    text-align:center;
    line-height:100px;
}

.nav_item a {
    text-decoration:none;
}

.nav_item:before, .nav_item:after {
    content:"";
    position:absolute;
    left:0px;
    width:100%;
    height:45%;
    background-color:rgba(var(--core-black-rgb), 0.25);
    backdrop-filter:blur(10px);
    -webkit-backdrop-filter:blur(10px);
    z-index:-1;
}

.nav_item:before {
    top:0px;
}

.nav_item:after {
    bottom:0px;
}

</style>
